<template>
  <b-popover ref="popover" :target="target" placement="bottomleft" triggers="click blur" :custom-class="customClass">
    <div class="menu">
      <template v-for="(item, index) in list">
        <a v-if="item.link" :key="index" class="menu-item" :href="item.link">
          <svg-icon
            v-if="item.icon"
            class="menu-item__icon"
            :size="16"
            :name="item.icon"
            :color="item.iconColor"
          ></svg-icon>
          {{ item.text }}
        </a>
        <div v-else :key="index" class="menu-item" @click="onClick(item)">
          <svg-icon
            v-if="item.icon"
            class="menu-item__icon"
            :size="16"
            :name="item.icon"
            :color="item.iconColor"
          ></svg-icon>
          {{ item.text }}
        </div>
      </template>
    </div>
  </b-popover>
</template>

<script>
import SvgIcon from "@/components/svg-icon";

export default {
  components: { SvgIcon },
  props: ["list", "target", "customClass"],
  methods: {
    onClick(item) {
      this.$emit("click", item);
      this.$refs.popover.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {
  &-item {
    display: flex;
    min-height: 30px;
    align-items: center;
    cursor: pointer;
    border-radius: 50px;
    padding: 4px 15px;
    font-size: 15px;
    line-height: 1.1;

    &:hover {
      background: #e1edff;
    }

    &__icon {
      margin-right: 12px;
      flex-shrink: 0;
    }
  }
}
</style>
